<template>
    <ds-modal
        class="feature-tour-modal"
        size="fullscreen"
        :is-open="isOpen"
    >
        <div class="modal-content">
            <ds-icon-button class="close-button" name="x" @click="$emit('close')" />

            <feature-tour-slides
                v-if="isOpen"
                :slides="slides"
                @complete="$emit('complete')"
            />
        </div>
    </ds-modal>
</template>

<script>
import FeatureTourSlides from './FeatureTourSlides';

export default {
    components: {
        FeatureTourSlides,
    },

    props: {
        isOpen: Boolean,
        slides: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss" scoped>
    .feature-tour-modal {
        --modal-background-color: #{$color-gray-050};
        --modal-padding: 0;
    }

    .modal-content {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    .close-button {
        position: absolute;
        top: $spacing-200;
        @include position-start($spacing-200);
        border: none;
        background: transparent;
    }
</style>
